import React, { useState, useEffect } from 'react';
import PlanCard from './PlanCard';
import PlanCardBulk from './PlanCardBulk';
import PlanSelector from './PlanSelector';
import PlanButtonSelector from './PlanButtonSelector';
import CampaignTerms from './CampaignTerms';
import DiscountCountdown from './DiscountCountdown';
import { courses } from './plans';
import { startDate, endDate } from "./discountPeriod";
import '../styles/PriceTableSelector.css';

// initialCourse を引数として受け取る
const PriceTableSelector = ({ initialCourse = "default" }) => {
  const [selectedCourse, setSelectedCourse] = useState(initialCourse);
  const [plans, setPlans] = useState(courses[selectedCourse].plans);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);


  const now = new Date();
  const isCampaignPeriod = now >= startDate && now < endDate;


  useEffect(() => {
    setPlans(courses[selectedCourse].plans);

    // Push selected course to Data Layer when a new course is selected
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'course_selection',
      selected_course: selectedCourse
    });
  }, [selectedCourse]);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 767);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);


  const planCards = plans.filter(plan => plan.monthly).map(plan => ({
    ...plan,
    discountedPrice: isCampaignPeriod ? plan.discountedPrice : null,
    isCampaignPeriod, // プロパティを追加
  }));

  const planCardBulks = plans.filter(plan => !plan.monthly).map(plan => ({
    ...plan,
    discountedPrice: isCampaignPeriod ? plan.discountedPrice : null,
    isCampaignPeriod, // プロパティを追加
  }));

  const isSingle = planCardBulks.length === 1;
  const availableCategories = courses[selectedCourse].available?.split(',').filter(Boolean);

  return (
    <section className="elt-wp-plugin pricing-section">
      <div id="scroll-target"></div>

      {/* PlanSelector or PlanButtonSelector based on screen size */}
      {isMobile ? (
        <PlanSelector onSelectCourse={setSelectedCourse} initialCourse={selectedCourse} />
      ) : (
        <PlanButtonSelector onSelectCourse={setSelectedCourse} initialCourse={selectedCourse} />
      )}

      {/* Display available categories if they exist */}
      {availableCategories && availableCategories.length > 0 && (
        <div className="box27">
          <span className="box-title">レッスン例</span>
          <div className="categories-container">
            {availableCategories.map((category, index) => (
              <div key={index} className="category-item">
                <img 
                  src="/wp-content/uploads/2024/09/shield-check-solid-gradientblue.svg"
                  alt="Check" 
                  className="category-icon"
                />
                <span>{category}</span>
              </div>
            ))}
          </div>
        </div>
      )}
      <DiscountCountdown />
      {/* Display PlanCard (monthly plans) */}
      {planCards.length > 0 && (
        <div className="plan-container plan-card-container">
          {planCards.map((plan, index) => (
            <PlanCard key={index} {...plan} />
          ))}
        </div>
      )}

      {/* Display PlanCardBulk (bulk purchase plans) */}
      {planCardBulks.length > 0 && (
        <div className={`plan-container plan-card-bulk-container ${isSingle ? 'single' : ''}`}>
          {planCardBulks.map((plan, index) => (
            <PlanCardBulk key={index} {...plan} isSingle={isSingle} />
          ))}
        </div>
      )}
      <CampaignTerms /> 
      <div className="pricing-notes">
        <div className="notes-container">
          <p className="notes-text">
            ※ 税込表示 <br />
          </p>
          <div className="additional-info">
            <ul className="info-list">
              <li className="info-item">
                <span className="info-border"></span>
                <span className="info-overlay"></span>
                入学金 ０円
              </li>
              <li className="info-item">
                <span className="info-border"></span>
                <span className="info-overlay"></span>
                市販テキスト 約3,000~10,000円
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PriceTableSelector;

